import { popStateDetected, isExitingEstate } from './ui.state';

export function setPopStateDetected(value: boolean): void {
  popStateDetected.value = value;
}

export function setIsExitingEstate(value: boolean): void {
  isExitingEstate.value = value;
}
